
import ResourceCard from "@/components/ResourceCard";
import { ResourceData } from "../data/resources";

interface ResourceGridProps {
  resources: ResourceData[];
}

const ResourceGrid = ({ resources }: ResourceGridProps) => {
  if (resources.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-xl font-medium mb-2">No resources found</h3>
        <p className="text-muted-foreground">Try adjusting your search query</p>
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {resources.map(resource => {
        // Use the isPreviewEnabled prop from the resource directly if needed
        return (
          <ResourceCard 
            key={resource.id}
            title={resource.title}
            description={resource.description}
            category={resource.category}
            isPremium={resource.isPremium}
            link={resource.link}
            readTime={resource.readTime}
            readCount={resource.readCount}
            likeCount={resource.likeCount}
            comingSoon={resource.comingSoon}
            isPreviewEnabled={resource.isPreviewEnabled}
          />
        );
      })}
    </div>
  );
};

export default ResourceGrid;
